/* assets/lazy-media.js
   Lazy-load <video> and <iframe> when near viewport.
*/
(() => {
  const supportsIO = 'IntersectionObserver' in window;

  const loadLazyVideo = (video) => {
    if (!video || video.dataset.loaded === 'true') return;
    video.querySelectorAll('source[data-src]').forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
    });
    // Start fetching/decoding only now
    video.load();
    video.dataset.loaded = 'true';
  };

  const loadLazyIframe = (iframe) => {
    if (!iframe || iframe.dataset.loaded === 'true') return;
    const src = iframe.getAttribute('data-src');
    if (src) {
      iframe.setAttribute('src', src);
      iframe.removeAttribute('data-src');
      iframe.dataset.loaded = 'true';
    }
  };

  const init = () => {
    const videos = document.querySelectorAll('video.js-lazy-video');
    const iframes = document.querySelectorAll('iframe.js-lazy-iframe');

    if (!supportsIO) {
      videos.forEach(loadLazyVideo);
      iframes.forEach(loadLazyIframe);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const el = entry.target;
          if (el.tagName === 'VIDEO') loadLazyVideo(el);
          if (el.tagName === 'IFRAME') loadLazyIframe(el);
          io.unobserve(el);
        }
      },
      { rootMargin: '300px 0px' }
    );

    videos.forEach((v) => io.observe(v));
    iframes.forEach((f) => io.observe(f));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
